export default ({ breakpoints, palette, spacing}) => ({
  root: {
    width: '100%',
  },
})
